import ProjectLocalSettings from "../../manager/project/project-local-settings"
import {ViewType} from "../../gd/const/views/view-type"
import {ProjectViewAccess} from "./@const"
import ApiProject from "../../gd/api/project"
import {EntityType} from "../../gd/const/item"
import {ViewTypeConfigs} from "../../gd/const/views/view-type-config"
import ErrorProto from "../../gd/validation/error"
import ErrorFieldRequired from "../../gd/validation/error-field-required"
// import projectViews_checkIsOldSystemView from "./functions/check-is-old-system-view"
import ProjectViews from "./project-views"
import {ProjectView_AccessControl} from "./access/acl"
import projectView_getAppSettings from "./actions/get-app-settings"
import {OpenProjectViewOptions, ProjectViewConfig} from "./@types"
import View from "../view/view"
import {Feature} from "../../gd/access-control/feature-access/const"
import RequestForm from "../form/request-form"
import ProjectView_MoreMenu from "../../../layout/top/header/project/submenu/submenu-item/more-popover/more-menu";
import header_toggleIsCompact
    from "../../../layout/top/header/project/submenu/toggle-button/function/toggle-is-compact";
import {TasksViewAppSettings} from "../../gd-modules/tasks-view/core/@types"

// const debug = "ProjectView"
const debug = false

export default class ProjectView extends View {

    // App Settings / View Settings
    // view settings are stored in separate place - project.viewAppSettings
    // because of
    // -- folder has view & view settins
    // ---- SubFolder inherites view but has its own view settings

    public config               : ProjectViewConfig // all params including appSettings and documentId (for PAGE view)

    public projectViews         : ProjectViews      // link to parent collection

    // public systemType           : ViewType
    public name                 : string        = 'view'    // use default from ViewTypeConfigs if not set?
    public access               : ProjectViewAccess = ProjectViewAccess.PUBLIC
    public userId?              : ID    // created by userId - view Owner userId
    // public sortPosition?        : number

    // public icon                 : string        // i think we'll need it even if not in use right now
    public url                  : string        = 'undefined' // view url
    public sharedViewId?        : ID

    protected _acl?             : ProjectView_AccessControl

    // inheritance
    public isInherited          : boolean   = false     // true if inhereted from parent folder ( or parent parent...)

    public hasMoreMenu          : boolean   = true      // not sure if we need it
    public showInSubmenu        : boolean   = true      // whether this view is shown in project submenu, currently is false for ViewType.PROJECT_NO_VIEWS only

    public canBeInherited       : boolean               // true if Inheritable false if not
    public hasTemplates         : boolean               // true if this type of view has presets (templates)
    public templateId?          : ID               // id of template (not preset) if used to create a view - not sure if we need it but we have it (UUID as public id)

    public actionItemsStorageId?: ID                    // New used for Project view todos

    constructor(viewConfig:ProjectViewConfig, projectViews:ProjectViews) {

        // Patch for old version?
        const type = _.get(viewConfig, 'systemType', ViewType.PROJECT_LIST)     // just in case task list no nam nado vsegda imet'
        viewConfig.id = (viewConfig.id?.toString() || type.toString()) as ID    // use systemType as id if not specified
        // end patch

        super(viewConfig, type, EntityType.PROJECT_VIEW)

        // this.systemType     = type

        this.projectViews   = projectViews

        this.config         = viewConfig



        debug && console.log(debug,"constructor", this.systemType, viewConfig)
        const viewTypeConfig = ViewTypeConfigs[this.systemType as ViewType]!

        this.name           = this.config.name || viewTypeConfig.menuName || 'View' // need it here
        this.access         = this.config.access || ProjectViewAccess.PUBLIC
        this.userId         = this.config.userId
        this.templateId     = this.config.templateId
        this.sortPosition   = !_.isNil(this.config.sortPosition) ? this.config.sortPosition : undefined
        this.icon           = viewTypeConfig.icon

        // without an id in the URL, navigation defaults to the first view of that type
        // every view URL should contains its unique id, so accessing a specific view doesn't depend on its sort position in submenu
        this.url            = 'p/{0}/{1}{2}'.f(this.projectViews.project.id, viewTypeConfig.url, /*projectViews_checkIsOldSystemView(this) ? '' :*/ '/' + this.id)

        this.sharedViewId   = this.config.sharedViewId
        this.isInherited    = viewConfig.isInherited || false

        if (this.systemType === ViewType.PROJECT_INFO || this.projectViews.project.isPage) {
            this.hasMoreMenu = false
        }

        this.canBeInherited = !!viewTypeConfig.inheritance
        this.hasTemplates   = !!viewTypeConfig.hasTemplates

        this.actionItemsStorageId  = this.config.actionItemsStorageId

        // #VIEW_APP_SETTINGS_PATCH: some sort of patch - very old vrode - need review
        if (!_.isEmpty(this.config.appSettings)) {
            this.projectViews.project.settings!.viewsAppSettings.setConfig(this.id, this.config.appSettings)
            this.resetLocalAppSettings() // just in case
        }
    }

    // Deprecated - need it for older code support
    get systemType():ViewType {
        return this.type
    }

    get acl():ProjectView_AccessControl {
        if (!this._acl) {
            this._acl = new ProjectView_AccessControl(this)
        }

        return this._acl
    }

    get isDefault() {
        return this.projectViews.project.settings!.defaultView === this.id
    }

    get isPrivate() {
        return this.access === ProjectViewAccess.PRIVATE
    }

    get isFirst() {
        return this.projectViews.getFirst().id === this.id
    }

    get isLast() {
        return this.projectViews.getLast().id === this.id
    }

    get feature() {
        switch (this.systemType) {
            case ViewType.PROJECT_WORKLOAD:
                return Feature.WORKLOAD
        }

        return undefined
    }

    // to customize open behaviour (for example for ProjectView_Link)
    open(options?: OpenProjectViewOptions) {
        if (this.acl.requiresUpgrade) {
            gd.modals.other.upgradeToPro(this.feature)
            return
        }

        if (this.type === ViewType.PROJECT_REQUEST_FORMS && !this.acl.canEditForm) {
            const fromConfig = _.find(this.projectViews.project.properties.forms, form=>form.id === this.config.formId)
            if (fromConfig) {
                const requestForm = new RequestForm(fromConfig)
                requestForm.open()
            }
            return
        }

        gd.navigation.goTo(this.url)
    }

    edit() {
        console.warn('ProjectView edit: is not implemented for systemType', this.systemType)
    }

    copyUrl() {
        const url = window.location.origin + '/' + this.url
        gd.utils.copyToClipboard(url)
        gd.growl.success('URL copied to clipboard.')
    }

    async rename() {
        return new Promise((resolve, reject) => {
            gd.modals.oneInput('Name', this.name, 'Rename', async (newName)=>{
                gd.modal.hide()

                this.name = newName

                // Refresh project menu
                gd.top.reRender()

                // save new project view name
                ApiProject.updateView(this, {name:this.name}, false)

                resolve(true)
            })
        })
    }

    async setAccess(access:ProjectViewAccess) {
        this.access = access

        const params: any = {
            access:this.access
        }

        if (access === ProjectViewAccess.PRIVATE) {
            // if no user specified then set current user
            if (!this.userId) {
                this.userId = gd.user.id
            }
            params.userId = this.userId
        }

        debug && console.log(debug, "setAccess", params, access)

        ApiProject.updateView(this, params)
    }

    /**--- App Settings [START] ---**/
    get appSettings(): DictionaryStringAny | undefined {
        return projectView_getAppSettings(this)
    }

    get appSettingsConfig(): TasksViewAppSettings | undefined {
        return this.projectViews.project.settings?.viewsAppSettings.getConfig(this.id) || undefined
    }

    // is required for appSettings inheritance
    get inheritedAppSettings():DictionaryStringAny | undefined {
        return projectView_getAppSettings(this, true)
    }

    get viewMoreMenu() {
        return ProjectView_MoreMenu
    }

    toggleIsCompactMenu() {
        header_toggleIsCompact(this.projectViews.project.id)
    }

    async saveAppSettings(newAppSettingsConfig:any, projectSettingsSave: boolean = true) {
        debug && console.log(debug,"---- saveAppSettings() start ------");

        if (!this.projectViews.project.settings) {
            console.error("#kdjhdue No Setting initialized")
            return
        }

        // remove OLD view.appSettings
        // currently appSettings are stored in project.settings.viewsAppSettings
        const view = _.find(this.projectViews.project.settings.views, v=>v.id === this.id)
        if (view) delete view.appSettings

        this.projectViews.project.settings.viewsAppSettings.setConfig(this.id, _.isEmpty(newAppSettingsConfig) ? null : newAppSettingsConfig)
        projectSettingsSave && await this.projectViews.project.settings.save()
        debug && console.log(debug, "--- saveAppSettings done ---")

        this.resetLocalAppSettings()
    }

    // local view appSettings are stored in ProjectLocalSettings
    // this method is only used to remove local settings when they're saved in viewsAppSettings
    // or while patching OLD view.appSettings (see #VIEW_APP_SETTINGS_PATCH in constructor)
    resetLocalAppSettings() {
        //reset view appSettings in projectLocalSettings if found
        const projectLocalSettings = new ProjectLocalSettings(this.projectViews.project.id)
        projectLocalSettings.resetViewAppSettings(this.id)
    }
    /**--- App Settings [END] ---**/

    validate():ErrorProto[] | null  {
        const errors : any[] = []

        if (!this.name) errors.push(new ErrorFieldRequired(gd.fields.projectView.name))

        if (_.isEmpty(errors)) return null
        else return errors
    }

    toJsonInheritance() {
        // what abouyt ID ?????? genrate new ID ? or same ID is OK ?
        // there should be no issue with identical views IDs in different projects

        const config = this.toJson()

        // Mark Project view as isInherited (dynamic)
        config.isInherited = true

        // shared view id should not be inherited
        delete config.sharedViewId

        return config
    }

    toJson() {
        const config : ProjectViewConfig = { // Stranno. Ne doljno li bit' JsonObject?!
            id              : this.id,
            systemType      : this.systemType,
            name            : this.name
        }

        if (this.sharedViewId)                                      config.sharedViewId = this.sharedViewId
        if (this.templateId) {
            config.templateId = this.templateId
        }
        if (this.userId)                                            config.userId           = this.userId
        if (!_.isNil(this.sortPosition))                            config.sortPosition     = this.sortPosition
        if (this.access && this.access!==ProjectViewAccess.PUBLIC)  config.access           = this.access
        if (this.actionItemsStorageId)                              config.actionItemsStorageId    = this.actionItemsStorageId

        return config
    }
}
